// extracted by mini-css-extract-plugin
module.exports = {"Layout":"styles_Layout__2nAOS","print":"styles_print___bz2G","light":"styles_light__2TGSm","dark":"styles_dark___xhKN","error":"styles_error__Fn6Np"};